import setGlobalState from '../../../redux/setGlobalState';
import store from '../../../store';
import type {AiAgentChatLang} from '../../../redux/aiAgent/aiAgent.type';
import type {ChatAskPrompt} from '../../aiMessageGenerator/utils/types';

const HEBREW_LETTER = /[\u0590-\u05FF]/;

const ANY_LETTER = /\p{L}/u;

export function detectChatLangFromText(text: string): AiAgentChatLang {
    return HEBREW_LETTER.test(text) ? 'he' : 'en';
}

/**
 * Lock chatLang only on the first free-text turn — not ask-option clicks, a picked list
 * number or image-only: text with no letters carries no language signal at all.
 */
export function shouldLockChatLang(
    prompt: string,
    pendingAsk: ChatAskPrompt | null | undefined,
): boolean {
    const trimmed = prompt.trim();
    if(!trimmed) {
        return false;
    }
    if(!ANY_LETTER.test(trimmed)) {
        return false;
    }
    const isOptionClick = !!pendingAsk?.options?.some(opt => opt.value === trimmed);
    return !isOptionClick;
}

/** The language of the first free-text turn is the one the chat keeps answering in. */
export function resolveChatLang(
    prompt: string,
    pendingAsk: ChatAskPrompt | null,
): AiAgentChatLang | null {
    const chatLang: AiAgentChatLang | null = store.getState().aiAgent?.chatLang ?? null;
    if(chatLang || !shouldLockChatLang(prompt, pendingAsk)) {
        return chatLang;
    }
    const detected = detectChatLangFromText(prompt);
    setGlobalState('aiAgent.chatLang', detected);
    return detected;
}
